// extracted by mini-css-extract-plugin
module.exports = {"valuePropCard":"style-module__valuePropCard___zfF1N","valuePropCardsContainer":"style-module__valuePropCardsContainer___hydbn"};